/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const fetchLandingPageTableData = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_TABLE_DATA}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postingPODetails = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_TABLE_DATA}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updatingPODetails = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_TABLE_DATA}/${data?._id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPreview = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_TABLE_DATA}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteTableEntery = async (id, data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_TABLE_DATA}/${id}`, { data: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPOTemplateList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_PO_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePOTemplate = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_PO_LIST}`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addNewPOTemplate = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_PO_LIST}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchEditPOTemplate = async (id) => {
  try {
    const poTemplateLibId = id;
    return await apiClient.get(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_PO_LIST}/${id}`, {
      params: { poTemplateLibId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editPOTemplateData = async (id, data) => {
  try {
    const poTemplateLibId = id;
    return await apiClient.put(`${apiEndpoint}${API.PO_TEMPLATE.FETCH_PO_LIST}/${id}`, { ...data }, { params: { poTemplateLibId } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicatePOTemplateData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PO_TEMPLATE.DUPLICATE_PO_TEMPLATE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPurchaseOrderList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.FETCH_PURCHASE_ORDER_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePurchaseOrder = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.FETCH_PURCHASE_ORDER}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadPoPdf = async (id, req) => {
  try {
    const purchaseOrderId = id;
    return await apiClient.post(
      `${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.DOWNLOAD_PURCHASE_ORDER}`,
      { ...req },
      {
        params: {
          purchaseOrderId,
        },
      },
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductAssociates = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE.GET_PRDUCT_ASSOC}`, { params: { tier: 'Tier2', isActive: true } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierList = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_SUPPLIER_TYPE_LIST}`, { params: { supplierType: id } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const savePurchaseOrder = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.FETCH_PURCHASE_ORDER}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPOById = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.FETCH_PURCHASE_ORDER}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getSupplierPOById = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.FETCH_SUPPLIER_PURCHASE_ORDER}`, { params: { purchaseOrderId: id } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllSupplierList = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.GET_ALL_TIER}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveEditPo = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.FETCH_PURCHASE_ORDER}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserContactDetails = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_USERS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicatePurchaseOrder = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.DUPLICATE_PURCHASE_ORDER}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const cancelPurchaseOrder = async (id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.FETCH_PURCHASE_ORDER}/${id}/status`, {});
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const sendEmailPurchaseOrder = async (id, data) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.SENT_EMAIL_TO_SUPPLIER}?purchaseOrderId=${id}`,
      { ...data },
      { purchaseOrderId: id },
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const approveRejectPurchaseOrder = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.APPROVE_REJECT_PO}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryUnitOfMeasure = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_UNIT_OF_MEASURE.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postPODocumentsService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PURCHASE_ORDER.SAVE_PO_DOCUMENT}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUploadedDocument = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_UPLOADED_DOCUMENT}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editPurchaseDocument = async (data, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.EDIT_PURCHASE_ORDER_DOCUMENT}`, { ...payload }, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePODocument = async (data, id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PURCHASE_ORDER.DELETE_PURCHASE_ORDER_DOCUMENT}/${id}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllUsers = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_MANAGEMENT.GET_COMPANY_USERS}`, {
      params: data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const serveTheLocalFileFromServer = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COMPONENT_PURCHASE_ORDER.LOCAL_FILE_SERVE}`, {
      params: { path: data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};
